<template>
    <div>
        <div class="tw-mt-4 tw-flex tw-items-start" v-for="(entry, index) in entries" :key="index">
            <input type="hidden" :name="`${namePrefix}[notify_department_settings][${index}][department_id]`" :value="entry.department_id">
            <input type="hidden" :name="`${namePrefix}[notify_department_settings][${index}][mode]`" :value="entry.mode">

            <div class="tw-flex tw-items-center tw-flex-1 tw-gap-4">
                <bordered-input>
                    <template #label>
                        <label :for="`notify_department_${index}`">
                            Abteilung
                        </label>
                    </template>
                    <template #input>
                        <select :id="`notify_department_${index}`"
                                class="tw-w-full"
                                v-model="entry.department_id">
                            <option :value="null" disabled>Bitte wählen…</option>
                            <option v-for="opt in normalizedOptions" :key="opt.id" :value="opt.id">{{ opt.label }}</option>
                        </select>
                    </template>
                </bordered-input>

                <bordered-input>
                    <template #label>
                        <label :for="`notify_mode_${index}`">
                            Benachrichtigungsmodus
                        </label>
                    </template>
                    <template #input>
                        <select :id="`notify_mode_${index}`"
                                class="tw-w-full"
                                v-model="entry.mode"
                        >
                            <option :value="null">Bitte wählen…</option>
                            <option value="all">Alle Mitarbeiter benachrichtigen</option>
                            <option value="manager">Nur den Abteilungsleiter benachrichtigen</option>
                        </select>
                    </template>
                </bordered-input>

                <div class="tw-flex tw-items-center tw-gap-2">
                    <button class="cu-btn-default" type="button" @click="addEntry">
                        <i class="fa fa-plus"></i>
                    </button>
                    <button class="cu-btn-default" type="button" @click="removeEntry(index)">
                        <i class="fa fa-trash-o"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="tw-mt-4" v-if="entries.length === 0">
            <button type="button" class="cu-btn-default" @click="addEntry">
                <i class="fa fa-plus"></i>
                Abteilung hinzufügen
            </button>
        </div>
    </div>
</template>

<script>
import BorderedInput from "./BorderedInput";

export default {
    components: { BorderedInput },
    props: {
        namePrefix: {
            type: String,
            required: true,
        },
        options: {
            type: [Array, String],
            required: true,
        },
        initialItems: {
            type: [Array, String],
            required: false,
            default: () => [],
        }
    },
    data() {
        return {
            entries: [],
            normalizedOptions: [],
        }
    },
    methods: {
        addEntry() {
            this.entries.push({ department_id: null, mode: 'all' });
        },
        removeEntry(index) {
            this.entries.splice(index, 1);
        }
    },
    mounted() {
        // Normalize props if they come as JSON strings from Blade
        let opts = this.options;
        if (typeof opts === 'string') {
            try { opts = JSON.parse(opts); } catch (e) { opts = []; }
        }
        this.normalizedOptions = opts;

        let init = this.initialItems || [];
        if (typeof init === 'string') {
            try { init = JSON.parse(init); } catch (e) { init = []; }
        }

        if (Array.isArray(init) && init.length > 0) {
            init.forEach(item => {
                this.entries.push({
                    department_id: item.department_id ?? item.id ?? null,
                    mode: item.mode ?? 'all',
                });
            });
        }
    }
}
</script>
